import React from "react";
import { useHistory } from "react-router-dom";
import { Segment, Container, Grid, Header, List } from "semantic-ui-react";
import apple from "Images/apple_app_store.png";
import android from "Images/google_play_badge.png";

const BottomSection = () => {
  const history = useHistory();

  return (
    <Segment className="bottom-section" vertical>
      <Container>
        <Grid divided stackable>
          <Grid.Row>
            <Grid.Column width={3}>
              <Header as="h4" content="About" />
              <List link>
                <List.Item as="a">Contact Us</List.Item>
                <List.Item
                  as="a"
                  onClick={() => {
                    history.push("/privacy_policy");
                  }}
                >
                  Privacy Policy
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => {
                    history.push("/terms_and_conditions");
                  }}
                >
                  Terms and Conditions
                </List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={4}>
              <Header as="h4">Mobile App</Header>
              <div>
                <a href="https://itunes.apple.com/us/app/facebook/id1441220855?mt=8">
                  <img
                    src={apple}
                    alt="Download on the App Store"
                    style={{ height: 48, paddingRight: 10 }}
                  />
                </a>
              </div>
              <div>
                <a href="https://play.google.com/store/apps/details?id=com.ivanchau.rhcccsystem&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                  <img
                    src={android}
                    alt="Get it on Google Play"
                    style={{ width: 186, marginLeft: -12 }}
                  />
                </a>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};

export default BottomSection;
